import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Stack)``;

export const UpdradeLink = styled(Link)`
  display: flex;
  text-align: center;
  text-decoration: none;
`;
